export default "__VITE_ASSET__Bo9VjSoX__"